export default {
  id: "topSellingProducts",
  name: "",
  description: "",
  report: {
    name: "Top Selling Products",
    chartType: "TABLE",
    template: "custom",
    config: {
      dataType: "single",
      dataSet: "Product",
      dimensions: ["Product.name"],
      measures: ["SaleItem.units_sold"],
      sort: {
        direction: "desc",
        by: "SaleItem.units_sold",
      },
      filters: [],
      compare: true,
      limit: "10",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
